import React from "react";
import { Box, Column, Columns, Table, Title } from "@allxsmith/bestax-bulma";


export default function Option({category, options}){
    // filter options for the category
    let filteredOptions = options.results.filter((option) => option.category.id === category.id);
    return (
        <Box>
            <details>
                <summary><Title>{category.name ?? "ERROR"}</Title></summary>
            <Columns isMultiline>
                <Column>
                    <Table
                        isFullwidth
                    >
                        <tr>
                            <th>Name</th>
                            <th>Status</th>
                        </tr>
                        <tbody>
                        {filteredOptions.map((item, index) => (
                            <tr key={item.xero_id}>
                                <td>{item.name}</td>
                                <td>{item.status}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                </Column>
            </Columns>
            </details>
        </Box>
    );


}